function overArg(func,transform){return function(arg){return func(transform(arg))}}module.exports=overArg;